import React from "react";
import AchivementArea from "../../common/AchivementArea";
import Breadcrumb from "../../common/Breadcrumb";
import JoinUs from "../../common/JoinUs";
import Sponsor from "../../common/Sponsor";
import Testimonial from "../../common/Testimonial";
import AboutWrap from "./AboutWrap";
import AboutTwoArea from "../home2/AboutTwoArea";
import AchivementTwo from "../home2/AchivementTwo"
import HomeTwoTestimonial from "../home2/HomeTwoTestimonial";
import HomeTwoSonsar from "../home2/HomeTwoSonsor";
function AboutPage() {
  return (
    <>
 <div className="background-image-unset bg-white">
    <Breadcrumb name="About Us" />
    <AboutTwoArea/>
    <AchivementTwo/>
    <HomeTwoTestimonial/>

     
      {/* <Testimonial /> */}
      <JoinUs padding="pt-120" />
      <HomeTwoSonsar/>
      {/* <Sponsor /> */}
    </div>

    </>
  );
}

export default AboutPage;
